import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { IconCheck } from '@americanexpress/dls-icons';

/**
 * returns DLS component for Icon with Label
 * @param {*} props
 */
const IconWithLabel = (props) => {
  const {
    iconName,
    filledFormData,
    selectKey,
    preFilledWith,
    isPreFilled,
  } = props;
  let preFilledVal;

  if (isPreFilled && preFilledWith === 'filledFormData') {
    if (filledFormData) {
      preFilledVal = filledFormData[selectKey];
    }
  }

  const [labelText, setLabelText] = useState(preFilledVal);

  useEffect(() => {
    setLabelText(preFilledVal);
  }, [preFilledVal]);

  const renderIConElem = (key) => {
    switch (iconName) {
      case 'IconCheck':
        return (
          <IconCheck
            title={key}
            titleId={key}
            size="sm"
            className="dls-green"
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="row">
      {
        typeof labelText === 'object' && Object.keys(labelText).length > 0 ? Object.keys(labelText).map((key) => (
          <div className="col-md-4" key={key}>
            {renderIConElem(key)}
            <span>
              {labelText[key]}
            </span>
          </div>
        ))
          : (
            <div className="col-md-12">
              {renderIConElem('check')}
              <span>
                {labelText}
              </span>
            </div>
          )
      }
    </div>
  );
};

IconWithLabel.propTypes = {
  preFilledWith: PropTypes.string,
  filledFormData: PropTypes.objectOf(PropTypes.shape),
  selectKey: PropTypes.string,
  isPreFilled: PropTypes.string,
  iconName: PropTypes.string,

};

export default IconWithLabel;
